<i18n>
{
	"en": {
		"trip": "Trip",
		"saveJson": "Save JSON",
		"cancel": "Cancel"
	},
	"no": {
		"trip": "Tur",
		"saveJson": "Lagre JSON",
		"cancel": "Avbryt"
	}
}
</i18n>
<template>
	<t-vertical-panel v-if="jsonObject">
		<div slot="header" class="trip-details-header">
			<t-panel-header icon="undefined" :text="`${$t('trip')} ${jsonObject.tripNumber ? jsonObject.tripNumber : ''}`"/>
			<div class="trip-details-header-sub-label" v-text="`JSON`"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="hideTripJson"
			/>
		</div>
		<div slot="sub-header" ref="subHeader" class="trip-details-sub-header">
			<div class="buttons-with-text">
				<t-button
					:value="$t('saveJson')"
					appearance="minimal"
					type="bp"
					iconBefore="tick"
					@click="saveTripJson"
				/>
				<t-button
					:value="$t('cancel')"
					appearance="minimal"
					type="bp"
					iconBefore="trash"
					intent="danger"
					@click="hideTripJson"
				/>
				<div/>
			</div>
		</div>
		<div v-show="!jsonLoading" class="details-content">
			<t-json-editor
				:jsonObject="jsonObject"
				:isInvalid="!!errorMessage"
				:validationMessage="errorMessage"
				resize="none"
				height="100%"
				@change="jsonChanged"
			/>
		</div>
		<t-overlay
			:isShown="jsonLoading"
			absolute
			loader
		/>
	</t-vertical-panel>
</template>

<script>
import rdbClient from 'rdb-client';
import { throwTranslatableError } from '@/core';
import { getTripByIdRequest, updateTripRequest } from './requests';
import { trip as validateTrip } from '@/modules/newTrip/validation';
export default {
	name: 'EditTripJson',
	components: { },
	props: { tripId: String },
	data() {
		return {
			errorMessage: null,
			jsonLoading: false,
			initialJsonObject: {},
			jsonObject: {},
			error: {}
		};
	},
	watch: {
		tripId: {
			async handler(val, oldVal) {
				if (!val || val === oldVal) return;
				this.jsonLoading = true;
				await this.getTripJson(val);
				this.errorMessage = null;
				this.jsonLoading = false;
			},
			immediate: true
		}
	},
	methods: {
		hideTripJson() {
			this.$emit('hide');
		},
		async saveTripJson() {
			document.activeElement.blur();
			if (this.errorMessage) return;
			this.jsonLoading = true;
			try {
				await this.saveTrip();
				this.errorMessage = null;
				this.$emit('changed', this.jsonObject);
			} catch (e) {
				this.errorMessage = e.message;
			}
			this.jsonLoading = false;
		},
		jsonChanged(value) {
			let jsonValue;
			try {
				jsonValue = JSON.parse(value);
				this.setJsonObject(jsonValue);
				this.errorMessage = null;
			} catch (e) {
				this.errorMessage = e.message;
			}
		},

		// Actions
		async saveTrip() {
			this.validate();
			if (this.error.isInvalid) {
				throw new Error('ValidationError');
			}
			let initialPatch = rdbClient.createPatch(this.initialJsonObject, this.jsonObject );
			try {
				let updatedTrip = await updateTripRequest(this.initialJsonObject.id, initialPatch);
				this.setTripJson(updatedTrip);
			} catch (e) {
				if (e.response && e.response.data && e.response.data && e.response.data.errors) {
					console.error(e.response.data.errors);
				}
				throwTranslatableError(e, 'failedToSave');
			}
		},
		async getTripJson(tripId) {
			try {
				let response = await getTripByIdRequest(tripId);
				this.setTripJson(response);
			} catch (e) {
				console.error(e);
			}
		},
		setTripJson(completeTrip) { // Only edit trip, not related (sub)orders
			if (completeTrip.orders)
				delete completeTrip.orders;
			this.setInitialJsonObject(completeTrip);
			this.setJsonObject(completeTrip);
		},

		// Mutations
		setInitialJsonObject(value) {
			if (!value) return;
			this.initialJsonObject = value;
		},
		setJsonObject(value) {
			if (!value) return;
			this.jsonObject = value;
		},
		validate() {
			this.error = validateTrip(this.jsonObject);
		},
	}
};
</script>

<style lang="scss" scoped>
.trip-details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 15px;
	.trip-details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}

.trip-details-sub-header {
	height: 100%;
	.buttons-with-text {
		display:grid;
		padding: 0px 10px;
		height: 100%;
		align-items: center;
		grid-template-columns: repeat(2, minmax(100px, max-content)) auto repeat(2, minmax(100px, max-content));
		grid-column-gap: 10px;
	}
	.buttons-no-text {
		display:grid;
		padding: 0px 10px;
		height: 100%;
		align-items: center;
		grid-template-columns: repeat(3, minmax(min-content, max-content)) auto repeat(3, minmax(min-content, max-content));
		grid-column-gap: 10px;
	}
}
.lowercase {
	text-transform: lowercase;
}

.details-content {
	min-height:100%;
	display: grid;
	background: white;
	// padding: 20px;
	row-gap: 20px;
	// grid-template-rows: repeat(2, minmax(min-content, max-content)) minmax(min-content, max-content);
}

</style>
